import PagePhase from '@/enum/PagePhase'

export default {
	breadcrumbTo: null,
	gameClientType: null, // GameClientType.Offline,
	gameType: null,

	currentTheme: null,
	currentCase: null,

	session: null, // Used to store student votes for one case

	lastEmojiCode: null,

	currentGamePhase: null,

	currentPageIndex: -1,
	currentPagePhase: PagePhase.Normal,
	pageHistory: [],

	gameClientCloseRedirectUrl: '/',

	errorMessage: null,
	errorIcon: null,
	navigationGuardEnabled: false,

	language: 'dk'
}
